import React, {useEffect} from 'react'
import useForm from '../hooks/useForm'
import {useRefData} from './RefData'
import {runsForPortfolio} from '../util/filters'
import {uniq} from 'lodash'
import useAuth from '../hooks/useAuth'

export const portfolioDefault = {portfolioId: null}
export const PortfolioContext = React.createContext(portfolioDefault)

export const PortfolioProvider = ({children}) => {
  const {organisationId} = useAuth()
  const storageKey = `com.blackalto.${organisationId}portfolio`

  const {ledgers, portfolios, runs} = useRefData('ledgers', 'portfolios', 'runs')
  const {values = {}, handleChange, setValue, setValues} = useForm({})
  const {portfolioId, runId} = values
  const portfolio = portfolios?.[portfolioId]
  const portfolioRuns = runsForPortfolio(runs || {}, portfolioId)
  const portfolioRunIds = portfolioRuns?.map(it => it.id)
  const run = portfolioRuns?.find(it => it.id === runId)
  const runDataset = run?.dataset

  const portfolioDatasets = portfolioRuns.map(run => {
    return uniq(Object.keys(ledgers?.[run.id]?.datasets || {}).concat(run.dataset.tradeDataset))
  })

  useEffect(() => {
    if (!organisationId) return
    const initialValues = localStorage.getItem(storageKey) ? JSON.parse(localStorage.getItem(storageKey)) : portfolioDefault
    setValues(initialValues)
  }, [organisationId])

  useEffect(() => {
    localStorage.setItem(storageKey, JSON.stringify({portfolioId, runId}))
  }, [values])

  useEffect(() => {
    if (!portfolios) return
    if (!portfolioId || portfolios[portfolioId] === undefined) {
      setValue('portfolioId', Object.keys(portfolios)[0])
    }
  }, [portfolios])

  let xtpId = portfolio && portfolio.xtpId
  return (
    <PortfolioContext.Provider value={{portfolioId, portfolio, runId, run, xtpId, portfolioRuns, portfolioRunIds, portfolioDatasets, portfolios, runDataset, handleChange}}>
      {children}
    </PortfolioContext.Provider>
  )
}

